<template>
  <button class="btn btn-secondary" @click="$emit('click')">
    {{button_name}}
  </button>
</template>

<script>
export default {
  name: "button_reset",
  props: [],
  data() {
    return {
      button_name: this.$t('button_reset')
    }
  }
}
</script>
